<template>
  <b-card title="อัพเดทคิว" class="mb-3">
    <b-row>
      <b-col md="6">
        <b-form-group>
          <h5 class="font-weight-bold">ด่านชายแดน</h5>
          <b-form-select v-model="selectedBorder" :options="options"
            :class="{ 'is-invalid': showError && !selectedBorder }" />
          <div class="invalid-feedback">กรุณาเลือกด่านชายแดน</div>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-card-text class="mt-1 mb-0 font-weight-bold mb-2" v-if="selectedBorder && count_data != 0">
          <template v-if="out_dateDefault">
            <span class="text-primary">
              คิวที่เหลือ:
              <strong>
                / ด่านชายแดน จังหวัด{{ selectedBorder }} / {{ count_data }}
              </strong>
              คิว
            </span>
          </template>

          <template v-else>
            <span class="text-danger">กรุณาเลือกวันที่</span>
          </template>
        </b-card-text>
      </b-col>

      <b-col md="6">
        <br />
        <b-form-group>
          <h5 class="font-weight-bold">วันที่เดินทางออกประเทศไทย</h5>
          <flat-pickr v-model="out_dateDefault" class="form-control"
            :class="{ 'is-invalid': showError && !out_dateDefault }" :config="outDateConfig" />
          <div class="invalid-feedback">วันที่เดินทางออกประเทศไทย</div>
        </b-form-group>
      </b-col>
      <div class="demo-inline-spacing">
        <h5 class="font-weight-bold">เลือกรอบ</h5>
        <!-- Primary -->
        <b-form-radio v-model="selected" name="some-radio9" value="รอบเช้า" class="custom-control-primary">
          รอบเช้า
        </b-form-radio>

        <!-- success -->
        <b-form-radio v-model="selected" name="some-radio9" value="รอบบ่าย" class="custom-control-success">
          รอบบ่าย
        </b-form-radio>
      </div>
      <b-col md="6">
        <b-form-group>
          <h5 class="font-weight-bold">วันที่เข้าประเทศไทย</h5>
          <flat-pickr v-model="in_dateDefault" class="form-control"
            :class="{ 'is-invalid': showError && !in_dateDefault }" :config="{ dateFormat: 'd-m-Y' }" />
          <div class="invalid-feedback">วันที่เข้าประเทศไทย</div>
        </b-form-group>
      </b-col>

      <!-- <b-card-text class="mt-1 mb-0">
      Selected: <strong>{{ selected }}</strong>
    </b-card-text> -->
    </b-row>
    </br>
    <!-- <b-col cols="12">
      <b-button variant="success" type="submit" @click.prevent="validationForm">
        อัพเดทคิว
      </b-button>
    </b-col> -->
    <b-col cols="12">
      <b-button variant="success" type="submit" @click.prevent="validationForm" :disabled="isLoading">
        <template v-if="isLoading">
          <b-spinner small type="grow" class="mr-1" />
          กำลังอัพเดทคิว...
        </template>
        <template v-else>
          อัพเดทคิว
        </template>
      </b-button>
    </b-col>
    <br />
    </br>
    <h4 class="text-primary font-weight-bold mb-2" v-if="items && items.length > 0">
      ข้อมูลแรงานต่างด้าว : {{ items.length }} รายการ
    </h4>

    <b-col cols="12">
      <b-table striped hover responsive :per-page="perPage" :current-page="currentPage" :items="items" :fields="fields"
        :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :filter="filter"
        :filter-included-fields="filterOn" @filtered="onFiltered">
      </b-table>
    </b-col>
  </b-card>
</template>

<script>
// ===== Vue & 3rd-party Plugins =====
import Ripple from "vue-ripple-directive";
import axios from "axios";

// ===== Project Modules =====
import store from "@/store/index";
import API from "@/connect/config";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
  components: {
    flatPickr,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      perPage: 100,
      pageOptions: [25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      fields: [
        { key: "no", label: "ลำดับที่" },
        { key: "IdCode", label: "เลขพาสปอร์ต/เลขที่ประจำตัว13หลัก" },
        { key: "prefix", label: "คำนำหน้า" },
        { key: "firstname", label: "ชื่อ" },
        { key: "lastname", label: "นามสกุล" },
        { key: "gender", label: "เพศ" },
        { key: "createdAtFormatted", label: "วันที่ลงทะเบียน" },
      ],
      items: [],
      selected: "รอบเช้า", // ✅ "รอบเช้า" ถูกเลือกโดยอัตโนมัติ
      selectedBorder: null, // ✅ ค่า default (ตรงกับ value: null)
      outDateConfig: {
        dateFormat: "d-m-Y",
        onChange: this.handleOutDateChange.bind(this),
      },
      options: [{ value: null, text: "-- เลือกด่านชายแดน --" }],
      formUser: {
        username: "",
        password: "",
        passwordFieldType: "password",
        firstname: "",
        lastname: "",
      },
      in_dateDefault: null, //new Date(), // หรือใช้ null, หรือ new Date() ก็ได้
      out_dateDefault: null, // new Date(), // หรือใช้ null, หรือ new Date() ก็ได้
      count_data: 0,
      showError: false,
      isLoading: false,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  created() {
    //  console.log(localStorage.getItem("data_addqueue"));
  },
  mounted() {
    this.getDataSelectOption();
    this.outDateConfig.onChange = this.handleOutDateChange;
    this.totalRows = this.items.length;
    this.getData();
  },
  watch: {
    selectedBorder(newVal) {
      if (newVal) {
        this.count_data = 0; // หากเลือกด่านชายแดน ให้รีเซตเป็น 0
      }

    },
  },
  methods: {
    async getData() {
      let dd = await store.getters.getChang;
      if (!dd || !dd[0] || !dd[0].length) {
        this.items = [];
        this.$router.push({ name: "search" });
        return;
      }
      const results = dd[0].map((item, index) => {
        return {
          ...item,
          no: index + 1,
        };
      });
      console.log("Data fetched:", results);
      this.items = results;
      this.totalRows = results.length;
      //   const dd = await this.$store.dispatch("data_addqueue");
      console.log(dd);

      this.items = results;
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async handleOutDateChange(selectedDates, dateStr) {
      console.log("📅 วันที่ออกถูกเลือก:", dateStr.split("-"));
      console.log("ด่านชายแดน:", this.selectedBorder);
      // ถ้ามีวันที่เลือก ให้ set 500
      //if (selectedDates && selectedDates.length > 0) {
      const [dayExit, monthExit, yearExit] = dateStr.split("-");
      try {
        const jwt = JSON.parse(localStorage.getItem("company_jwt"));
        const params = {
          staffId: jwt.userId,
          date: `${yearExit}${monthExit}${dayExit}`,
        };
        console.log("Request Params", params);
        const res = await axios.get(`${API}queueStatus`, {
          params,
          headers: {
            Authorization: await store.dispatch("getAuthorization"),
          },
        });
        console.log(res.data);


        const stationData = res.data.message.stations.find(
          (station) => station.stationName.trim() === this.selectedBorder.trim()
        );

        this.count_data = stationData.remaining; // รีเซ็ตค่า count_data ก่อนคำนวณใหม่

        // console.log("API Response", stationData)
        return stationData.remaining;
      } catch (err) {
        console.error("❌ Error:", err.response?.data || err.message);
      } finally {
        this.isBusy = false;
      }
    },
    async getDataSelectOption() {
      const jwt = JSON.parse(localStorage.getItem("company_jwt"));
      try {
        const res = await axios.get(`${API}config?userId=${jwt.userId}&configType=station`,
          {
            headers: {
              Authorization: await store.dispatch("getAuthorization"),
            },
          });
        console.log("✅ success");
        const responseData = res.data.message.data;


        // แปลงข้อมูลให้ตรงกับรูปแบบ dropdown
        const dynamicOptions = responseData.map((item) => ({
          value: item.stationName, // สมมติ field ชื่อ borderName
          text: item.stationName,
        }));

        // รวม option แรก + ตัวเลือกจาก API
        this.options = [{ value: null, text: "-- เลือกด่านชายแดน --" }, ...dynamicOptions];
      } catch (err) {
        if (err.response) {
          console.error("❌ API Error:", err.response.status);
          console.error("Response:", err.response.data);
        } else {
          console.error("❌ Error:", err.message);
        }
      }
    },
    // async validationForm() {
    //   this.showError = !this.out_dateDefault;
    //   if (this.showError) {
    //     // หยุดการ submit
    //     return;
    //   }
    //   const { username, password, firstname, lastname } = this.formUser;
    //   const jwt = JSON.parse(localStorage.getItem("company_jwt"));
    //   //   console.log(jwt);
    //   console.log(this.items);
    //   const res_data =  this.items.map(async item => {
    //     const registeredExitDate = this.out_dateDefault;
    //     const [day, month, year] = registeredExitDate.split("-");

    //     const registeredEntryDate = this.out_dateDefault;
    //     const [day2, month2, year2] = registeredEntryDate.split("-");

    //     const _status =
    //       [{ "ลงทะเบียน": "สำเร็จ" },
    //       { "จ่ายเงิน": "สำเร็จ" },
    //       { "สร้างบัตร": "รอดําเนินการ" },
    //       ]

    //     const _data = {
    //       userId: item.userId,
    //       shift: this.selected,
    //       entryId: item.entryId,
    //       IdCode: item.IdCode,
    //       registeredExitDate: `${year}${month}${day}`,
    //       registeredEntryDate: `${year2}${month2}${day2}`,
    //       stationName: this.selectedBorder,
    //       staffId: jwt.userId,
    //       // processingStatus: JSON.stringify(_status)
    //     }
    //     // console.log("Data to send:", _data);

    //     axios.put(`${API}confirmEntry`, _data, {
    //         headers: {
    //           Authorization: await store.dispatch("getAuthorization"),
    //         },
    //       })
    //   });
    //   console.log("res_data:", res_data);
    //   this.count_data = await this.handleOutDateChange(this.out_dateDefault, this.out_dateDefault);



    //   //   this.handleOutDateChange(this.out_dateDefault, this.out_dateDefault); 
    //   console.log("handleOutDateChange:");
    //   console.log("รอบที่เลือก:", this.selected);
    //   console.log("วันที่ที่เลือก:", this.in_dateDefault);
    //   console.log("วันที่ที่เลือก:", this.out_dateDefault);

    //   this.$swal({
    //     icon: "success",
    //     title: "บันทึกข้อมูล!",
    //     text: "บันทึกข้อมูลสำเร็จ",
    //     showCancelButton: false,
    //     showConfirmButton: true,
    //     timer: 1500,
    //     customClass: {
    //       confirmButton: "btn btn-success",
    //     },
    //   });


    //   return;

    // },
    async validationForm() {
  this.showError = !this.out_dateDefault;
  if (this.showError) return;

  const jwt = JSON.parse(localStorage.getItem("company_jwt"));
  const [day, month, year] = this.out_dateDefault.split("-");
  const [day2, month2, year2] = this.in_dateDefault.split("-");

  this.isLoading = true;

  try {
    // 👉 ดึง token แค่ครั้งเดียว
    const token = await store.dispatch("getAuthorization");

    await Promise.all(
      this.items.map((item) => {
        const _status = [
          { "ลงทะเบียน": "สำเร็จ" },
          { "จ่ายเงิน": "สำเร็จ" },
          { "สร้างบัตร": "รอดําเนินการ" },
        ];

        const _data = {
          userId: item.userId,
          shift: this.selected,
          entryId: item.entryId,
          IdCode: item.IdCode,
          registeredExitDate: `${year}-${month}-${day}`,   // YYYY-MM-DD
          registeredEntryDate: `${year2}-${month2}-${day2}`, // YYYY-MM-DD
          stationName: this.selectedBorder,
          staffId: jwt.userId,
          processingStatus: JSON.stringify(_status),
        };

        console.log("➡️ ส่งข้อมูล:", _data);

        return axios.put(`${API}confirmEntry`, _data, {
          headers: { Authorization: token },
        });
      })
    );

    // อัพเดทข้อมูลหลังจาก save สำเร็จ
    this.count_data = await this.handleOutDateChange(
      this.out_dateDefault,
      this.out_dateDefault
    );

    // ✅ ถ้าทุก request สำเร็จ
    this.$swal({
      icon: "success",
      title: "บันทึกข้อมูล!",
      text: "บันทึกข้อมูลสำเร็จ",
      timer: 1500,
      showConfirmButton: true,
      customClass: {
        confirmButton: "btn btn-success",
      },
    });
  } catch (error) {
    console.error("❌ Error:", error.response?.data || error.message);

    this.$swal({
      icon: "error",
      title: "เกิดข้อผิดพลาด!",
      text: "ไม่สามารถบันทึกข้อมูลได้",
      showConfirmButton: true,
      customClass: {
        confirmButton: "btn btn-danger",
      },
    });
  } finally {
    this.isLoading = false;
  }
}


  },
};
</script>